import { PdfFileTypeIcon } from '@commenda/icons';
import { getFileIcon } from '@commenda/utils';
import { XIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { getAttachmentIconExt, getAttachmentKind } from './attachment-kind';
import { AttachmentPreviewHoverCard } from './AttachmentPreviewHoverCard';

interface AttachmentPillProps {
  fileName: string;
  mimeType: string;
  fileRef?: string;
  onRemove?: () => void;
  icon?: ReactNode;
}

export function AttachmentPill({
  fileName,
  mimeType,
  fileRef,
  onRemove,
  icon,
}: AttachmentPillProps) {
  const { kind } = getAttachmentKind(mimeType, fileName, fileRef);
  const iconExt = getAttachmentIconExt(kind, fileName, fileRef);

  const FileTypeIcon =
    kind === 'pdf'
      ? PdfFileTypeIcon
      : getFileIcon(iconExt ? `file.${iconExt}` : fileName);

  const pill = (
    <span className="flex min-w-0 max-w-64 items-center gap-sm rounded-md border-[0.5px] border-border-primary bg-bg-primary py-xs pl-xs pr-sm shadow-[0px_2px_4px_0px_rgba(0,0,0,0.04)]">
      <span className="flex size-4 shrink-0 items-center justify-center [&>svg]:size-full">
        {icon ?? <FileTypeIcon />}
      </span>

      <span className="truncate txt-extra-small-medium text-text-primary">
        {fileName}
      </span>

      {onRemove && (
        <button
          type="button"
          aria-label={`Remove ${fileName}`}
          onClick={onRemove}
          className="flex size-4 shrink-0 cursor-pointer items-center justify-center rounded-sm border-none bg-transparent text-fg-tertiary transition-colors hover:text-text-primary"
        >
          <XIcon className="size-4" aria-hidden="true" />
        </button>
      )}
    </span>
  );

  if (!fileRef) return pill;

  return (
    <AttachmentPreviewHoverCard
      fileName={fileName}
      mimeType={mimeType}
      fileRef={fileRef}
    >
      {pill}
    </AttachmentPreviewHoverCard>
  );
}
